export default __webpack_public_path__ + "static/media/washupStep1.ba2a803e.png";